export default __webpack_public_path__ + "static/stevenhasnoot-434485b40fa77e0f4ad57fb4b8a51bcb.jpg";